import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BasicModal from "../../core/BaseComponents/Modal";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { callAPI } from "../../../axios";
import { getChainIdLS } from "../../../utils/utils";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

function CarouselComponent(props) {
  const sliderRef = useRef(null);
  const [reOrderImages, setReOrderImages] = useState([]);
  const [sequenceOrder, setSequenceOrder] = useState([]);
  const [reOrderDisabled, setReOrderDisabled] = useState('');
  const { chainId } = useSelector((state) => state.chainIdReducer);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: props?.initialSlide
  };

  const textPostionClass = (selectedTextPosition) => {
    if (selectedTextPosition === "Top Left") {
      return 'top-left top-left-child-img'
    } else if (selectedTextPosition === "Top Right") {
      return 'top-right top-right-child-img'
    } else if (selectedTextPosition === "Centered") {
      return 'center'
    } else if (selectedTextPosition === "Bottom Right") {
      return 'bottom-right bottom-right-child-img'
    }
    else if (selectedTextPosition === "Bottom Left") {
      return 'bottom-left bottom-left-child-img'
    }
  }

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const [reorderedItem] = sequenceOrder.splice(result.source.index, 1);
    sequenceOrder.splice(result.destination.index, 0, reorderedItem);

    callAPI(`/banner/reorder?bannerConfigId=${props?.listConfigId}`, "PUT", sequenceOrder, { chainId: getChainIdLS() })
      .then(function (response) {
        // console.log(response);
        reOrderList();
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const reOrderList = () => {
    callAPI(`/config/get?configId=${props?.listConfigId}`, "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setReOrderDisabled(res?.published)
        setReOrderImages(res?.bannerImage);
        setSequenceOrder(res?.bannerImage.map((item) => item?.id))
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }

  useEffect(() => {
    reOrderList();
  }, [props, chainId]);

  const handleDelete = (url, id)=>{
    props?.handleDeleteBannerAPI(url, id)
  }

  const handleIntialSlideImage = (index)=>{
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  }

  return (
    <BasicModal
      popupOpen={props?.showPreviewPopUp}
      popupCloseHandler={() => { props.setShowPreviewPopUp(false); props?.BannerListApi() }}
      isCross={true}
      heading={<p className="mb-2">Hero Banner Images Preview</p>}
      popupSize='col-10'
      bodyMessage={
        <>
          {
            reOrderImages?.length > 1 ? <>
              <Slider {...settings} ref={sliderRef} className="preview-slider-image mx-4">
                {reOrderImages?.map((bannerImagesList) =>
                <>
                <div className="row">
                      <div className={`${bannerImagesList?.selectionType==="IMAGE"?"col-8":"col-12"}`}>
                      <img src={bannerImagesList?.url} className="rounded-1" alt={bannerImagesList?.id} style={{border:`5px solid #${bannerImagesList?.gradientColor}`}}/>
                      </div>
                      {(bannerImagesList?.selectionType==="IMAGE") && 
                      <div className="col-4 ps-0">
                      <img src={bannerImagesList?.childImageUrl} alt={bannerImagesList?.childImageUrl} width={100} loading="lazy" style={{height:'50vh'}}/>
                      <p className={textPostionClass(bannerImagesList?.textPosition)}>{bannerImagesList?.text}</p>
                      <p className="text-black">Linked Image</p>
                      </div>
                      }
                    </div>
                {(bannerImagesList?.selectionType==="WEB_LINK" || bannerImagesList?.selectionType==="YOUTUBE_LINK") && <span className="d-flex">{bannerImagesList?.selectionType}: &nbsp;<a className="d-flex" target="_blank" href={bannerImagesList?.link} rel="noreferrer">{ bannerImagesList?.link}</a></span>}
                </>
                )}
              </Slider>
            </> : <div className="preview-banner-img group-rooms-single-img">
              <div className="row">
                <div className={`${reOrderImages[0]?.selectionType==="IMAGE"?"col-8":"col-12"}`}>
                <img src={reOrderImages[0]?.url} alt={reOrderImages[0]?.id} width={100} style={{border:`5px solid #${reOrderImages[0]?.gradientColor}`}} className="rounded-1" />
                </div>
              {(reOrderImages[0]?.selectionType==="IMAGE") &&
               <div className="col-4 position-relative ps-0">
                <img src={reOrderImages[0]?.childImageUrl} alt={reOrderImages[0]?.childImageUrl} width={100} loading="lazy" style={{height:'50vh'}}/>
               <p className={textPostionClass(reOrderImages[0]?.textPosition)}>{reOrderImages[0]?.text}</p>
               <p className="text-black">Linked Image</p>
               </div>}
              </div>
              {(reOrderImages[0]?.selectionType==="WEB_LINK" || reOrderImages[0]?.selectionType==="YOUTUBE_LINK") && <spn className="d-flex">{reOrderImages[0]?.selectionType}: &nbsp;<a className="d-flex" target="_blank" href={reOrderImages[0]?.link} rel="noreferrer">{reOrderImages[0]?.link}</a></spn>}
            </div>
          }
          {reOrderImages.length > 1 &&
            <div className="mt-5">
              <h6 className="text-start mb-3">Re-Order / Delete Hero Banner Images</h6>
              {
                reOrderDisabled ? <div className="delete-config-images justify-content-center">
                  {reOrderImages?.map((url) => <Tooltip placement="top" title='Un-Publish to re-order images'>
                    <div>
                      <img
                        src={url?.url}
                        alt={url?.id}
                        className="undrag-images"
                      />
                      <Tooltip title={`${reOrderImages?.length === 1 ? 'At least one image required in hero banner' : reOrderDisabled ? "Un-Publish to perform actions" : props?.editBannerSid?.id === props?.listConfigId ? "Cancel edit mode to perform actions" : 'Delete'}`}>
                        <span className={`${reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid?.id === props?.listConfigId ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid.id === props?.listConfigId ? "" : ""}>X</span>
                      </Tooltip>
                    </div>
                  </Tooltip>)}
                </div> : <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided) => (
                      <div
                        className="delete-config-images justify-content-center"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {reOrderImages?.map((url, index) => (
                          <Draggable key={String(url?.id)} draggableId={String(url?.id)} index={index}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <img
                                  src={url?.url}
                                  alt={url?.id}
                                  className="drag-images"
                                  onClick={()=> handleIntialSlideImage(index)}
                               />
                                <Tooltip title={`${reOrderImages?.length === 1 ? 'At least one image required in hero banner' : reOrderDisabled ? "Un-Publish to perform actions" : props?.editBannerSid?.id === props?.listConfigId ? "Cancel edit mode to perform actions" : 'Delete'}`}>
                                  <span className={`${reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid?.id === props?.listConfigId ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid?.id === props?.listConfigId ? "" : handleDelete(url, props?.listConfigId)}>X</span>
                                </Tooltip>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              }
            </div>
          }
        </>
      }
    />
  );
}

export default CarouselComponent;
